import React from "react";
import { useTranslations } from "next-intl";

import { useTheme } from "@/context/Theme.context";
import { Modal, ShowWhen } from "@/components/common";
import UserInfoDetails from "./user-info-details";
import RefillBalance from "../refill-balance/refill-balance";
import {
  DoorIcon,
  FemaleIcon,
  MaleIcon,
  WalletIcon,
} from "@/components/assets/icons";

import { useGetBasicUserDataRequest } from "@/api/useGetBasicUserDataRequest";
import { useGetBalanceInfoRequest } from "@/api/useGetBalanceInfoRequest";

import { Theme } from "@/enums";
import { useModal } from "@/hooks/useModal";
import useGetMainInfoDataRequest from "@/api/useGetMainInfoDataRequest";
import { useGetInterfaceLanguageRequest } from "@/api/useGetInterfaceLanguageRequest";
import { displayFullName } from "@/utils/fullName.util";
import { formatNumber } from "@/utils/formatNumber";

const UserInfo = () => {
  const t = useTranslations();
  const theme = useTheme();
  const { openModal, closeModal, modalOpen } = useModal();

  const { data: roomDetails, isLoading: roomsIsLoading } =
    useGetBasicUserDataRequest();
  const { data: balanceInfoData, isLoading: isBalanceLoading } =
    useGetBalanceInfoRequest();

  const { data: languageData } = useGetInterfaceLanguageRequest();

  const selectedLang = languageData?.data?.data?.lang;

  const { data: mainInfoData } = useGetMainInfoDataRequest();

  const mainInfo = mainInfoData?.data?.data;

  const displayCurrency =
    theme === Theme.GEORGIA ? "gel" : theme === Theme.UK ? "usd" : "uzs";

  let balance = balanceInfoData?.data?.data?.balanceNational || 0;
  if (theme === Theme.UK) {
    balance = balanceInfoData?.data?.data?.balanceUsd || 0;
  }

  const fullName = displayFullName({ selectedLang, mainInfo });

  return (
    <>
      <div className="flex w-full flex-row items-center gap-6 rounded-3xl bg-white px-[1.875rem] py-8 lg:h-[133px]">
        <ShowWhen condition={!roomsIsLoading && !isBalanceLoading}>
          <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-stone-50 p-6">
            {mainInfo?.sex === false ? <FemaleIcon /> : <MaleIcon />}
          </div>
          <div className="w-full">
            <h1 className="text-xl font-bold text-neutral-900">{fullName}</h1>
            <div className="mt-[14px] flex flex-wrap gap-2">
              <UserInfoDetails
                icon={DoorIcon}
                title="room_number"
                description={
                  theme === Theme.UK
                    ? roomDetails?.data?.data?.roomNumber || ""
                    : roomDetails?.data?.data?.roomNumberToShow || ""
                }
              />
              <div id="refill-balance">
                <UserInfoDetails
                  icon={WalletIcon}
                  title="balance"
                  description={`${formatNumber(balance)} ${t(displayCurrency)} `}
                  openModal={openModal}
                />
              </div>
            </div>
          </div>
        </ShowWhen>
      </div>
      <Modal
        showCloseIcon
        title="refill_balance"
        isOpen={modalOpen}
        closeModal={closeModal}
      >
        <RefillBalance />
      </Modal>
    </>
  );
};

export default UserInfo;
